module.exports = __webpack_public_path__ + "img/icn_essential.1f41f2f8.svg";